import { z } from 'zod'
import { env } from 'configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'
import { PaginationSchema, Validate } from './SchemaValidation'

const HelpdeskService = {}

HelpdeskService.deleteTicket = ticketId => {
  return fetch({
    url: `${env.HELPDESK_ENDPOINT_URL}/api/ticket/${ticketId}`,
    method: 'DELETE',
  })
}

HelpdeskService.getTicket = ticketId => {
  return fetch({
    url: `${env.HELPDESK_ENDPOINT_URL}/api/ticket/${ticketId}`,
    method: 'GET',
  })
}

HelpdeskService.listTickets = function (params) {
  return fetch({
    url: `${env.HELPDESK_ENDPOINT_URL}/api/ticket`,
    method: 'GET',
    params: Validate(PaginationSchema, params),
  })
}

const postTicketSchema = z.object({
  title: z.string(),
  description: z.string(),
  ticket_category_id: z
    .number()
    .refine(value => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(value)),
  ticket_priority_id: z.number().refine(value => [1, 2, 3].includes(value)),
})

HelpdeskService.postTicket = data => {
  return fetch({
    url: `${env.HELPDESK_ENDPOINT_URL}/api/ticket`,
    method: 'POST',
    data: Validate(postTicketSchema, data),
  })
}

const postCommentSchema = z.object({
  comment: z.string(),
})

HelpdeskService.postComment = rawData => {
  const { id, ...data } = rawData
  return fetch({
    url: `${env.HELPDESK_ENDPOINT_URL}/api/ticket/${id}/comment`,
    method: 'POST',
    data: Validate(postCommentSchema, data),
  })
}

HelpdeskService.updateTicket = data => {
  const { id, ...body } = data
  return fetch({
    url: `${env.HELPDESK_ENDPOINT_URL}/api/ticket/${id}`,
    method: 'PUT',
    data: Validate(postTicketSchema, body),
  })
}

export default HelpdeskService
